import React, { useCallback, useEffect, useState } from "react";
import "../../../css/print.css"
import { useParams } from "react-router-dom";
import api from "../../../api/api";

export default function PrescriptionToPrint() {

    const { patientId, prescriptionId } = useParams();

    const [prescriptionToPrint, setPrescriptionToPrint] = useState(null);

    const getPrescriptionToPrint = useCallback(() => {
        api.get(`/receituario/${patientId}/${prescriptionId}/print`, {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then((returnFromApi) => {
            setPrescriptionToPrint(returnFromApi.data);
        }).catch((returnFromApi) => {
            console.error("ops! ocorreu um erro" + returnFromApi);
        });
    }, [patientId, prescriptionId]);

    useEffect(() => {
        getPrescriptionToPrint();

        const handleAfterPrint = () => {
            window.close();
        };
        document.body.classList.add("printing-active");
        window.addEventListener("afterprint", handleAfterPrint);

        const timer = setTimeout(() => {
            window.print();
        }, 500);

        return () => clearTimeout(timer);
    }, [getPrescriptionToPrint]);

    return (
        <div className="container d-none d-print-block">
            <div className="text-center mt-5">
                <h5>Receituário</h5>
            </div>

            <div className="mt-5">
                <p>Paciente: {prescriptionToPrint?.nomeDoPaciente}</p>
                <p>Dentista: {prescriptionToPrint?.nomeDoDentista}</p>
            </div>

            <div className="mt-5">
                <p>Uso Interno</p>
                {prescriptionToPrint?.medicamentos.map((medicamento) => {
                    return <div class="d-flex">
                        <div class="flex-1">
                            <p class="mb-0"><strong>{medicamento.nome} - {medicamento.descricaoQuantidade}</strong></p>
                            <p class="fs--1 mb-0 text-600">{medicamento.posologia}</p>
                            <div class="border-bottom border-dashed my-3"></div>
                        </div>
                    </div>
                }
                )}
            </div>

            <div className="text-center mt-5">
                <p>Data: {prescriptionToPrint?.data}</p>
                <p>______________________________</p>
                <p>Assinatura do Profissional</p>
            </div>
        </div>
    );
}